import React from "react";
import { useTranslation } from "react-i18next";
import { InputText, InputTextProps } from "primereact/inputtext";

export function GlobalFilter(props: InputTextProps) {
  const { t } = useTranslation();

  return (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText type="search" onInput={props.onInput} placeholder={t("common.search")} />
    </span>
  );
}
